import { render, staticRenderFns } from "./ProcessLoaderComponent.vue?vue&type=template&id=648761f2&scoped=true"
import script from "./ProcessLoaderComponent.vue?vue&type=script&lang=js"
export * from "./ProcessLoaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648761f2",
  null
  
)

export default component.exports